<template>
    <div>
        <div class="top-bar clearfix">
            <a class="close" href="#" @click.prevent="close" title="Close" arial-label="Close">
                <span class="vert-spacer"></span>
                <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'circle-xmark']" aria-hidden="true"></fa-icon></span>
            </a>
        </div>
        <div class="content">
            <h2>General Info</h2>
            <div class="data">
                <div class="data-item">
                    <label>Id: </label>
                    <span>{{ userContext.id }}</span>
                </div>
                <div class="data-item">
                    <label>Device Id: </label>
                    <span>{{ userContext.did }}</span>
                </div>
                <div class="data-item">
                    <label>Server: </label>
                    <span>{{ userContext.instance }}</span>
                </div>
                <div class="data-item">
                    <label>Application: </label>
                    <span>{{ userContext.app }}</span>
                </div>
                <div class="data-item">
                    <label>System: </label>
                    <span>{{ userContext.sys }}</span>
                </div>
            </div>
            <h2>Services</h2>
            <div class="data">
                <div v-for="item in services" class="data-item">
                    <label>{{ item.name }}: </label>
                    <span>{{ item.url }}</span>
                </div>
            </div>
            <h2>Claims</h2>
            <div class="data">
                <div v-for="item in userContext.claims" class="data-item">
                    <label>{{ item.type }}: </label>
                    <span>{{ item.val }}</span>
                </div>
            </div>
            <h2>Settings</h2>
            <div class="data">
                <div v-for="item in userSettings" class="data-item">
                    <label>{{ item[0] }}: </label>
                    <span>{{ item[1] }}</span>
                </div>
            </div>
            <h2>User Info</h2>
            <div v-if="userContext.user == null">
                <p>Not logged in.</p>
            </div>
            <div v-else class="data">
                <div class="data-item">
                    <label>Id: </label>
                    <span>{{ userContext.user.id }}</span>
                </div>
                <div class="data-item">
                    <label>Username: </label>
                    <span>{{ userContext.user.username }}</span>
                </div>
                <div class="data-item">
                    <label>Account: </label>
                    <span>{{ userContext.user.accountNum }} - {{ userContext.user.accountName }} ({{ userContext.user.accountId }})</span>
                </div>
                <div class="data-item">
                    <label>CSR: </label>
                    <span>{{ userContext.user.csrName }} ({{ userContext.user.csrId }})</span>
                </div>
                <div class="data-item">
                    <label>Name: </label>
                    <span>{{ userContext.user.firstName }} {{ userContext.user.lastName }}</span>
                </div>
                <div class="data-item">
                    <label>Screen name: </label>
                    <span>{{ userContext.user.screen }}</span>
                </div>
                <div class="data-item">
                    <label>Email: </label>
                    <span>{{ userContext.user.email }}</span>
                </div>
                <div class="data-item">
                    <label>Mobile: </label>
                    <span>{{ userContext.user.mobile }}</span>
                </div>
                <div class="data-item">
                    <label>Phone: </label>
                    <span>{{ userContext.user.phone }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>import script from './contextInfo';
    export default script;</script>

<style lang="less" scoped>
    @import "./contextInfo.less";
</style>
